export const SmtpEnum = {
  NEDESIFRIRANA_POVEZAVA_Z_AVTENTIKACIJO: '25',
  SIFRIRANA_POVEZAVA_PREK_SSL_ALI_TLS_PROTOKOLA: '465',
  SIFRIRANA_POVEZAVA_PREK_STARTLS_PROTOKOLA: '587'
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/ElektronskaPostaNastavitve/SmtpEnum.js